<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title">{{ title ? title : 'Confirmation' }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div>{{ content }}</div>
    <div class="form-group mt-4">
      <strong>{{remarksLabel}}</strong>
      <br/>
      <textarea [(ngModel)]="remarks" class="form-control"></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-main" (click)="yes()">Yes</button>
    <button type="button" class="btn btn-secondary" (click)="close()">No</button>
  </div>

</div>